import { type NavigateFunction } from 'react-router-dom';
import env from '../config/env';
import { pages } from './pages';
import { CONTACT_US_SWAP, CONTACT_US_WELCOME, FAQ_LINK } from './redirectLinks';

const redirectToLogin = (): void => {
  window.location.assign(`${env.LOGIN_URL}?origin=${window.location.href}`);
};

const redirectToDashboard = (): void => {
  window.location.assign(`${env.SITE_URL}`);
};

const redirectToTrialCancel = (): void => {
  window.location.assign(`${env.SITE_URL}/trial-cancel-subscription`);
};

const redirectToFAQ = (): void => {
  window.location.assign(FAQ_LINK);
};

const redirectToContactUsSwap = (): void => {
  window.location.assign(CONTACT_US_SWAP);
};

const redirectToContactUsWelcome = (): void => {
  window.location.assign(CONTACT_US_WELCOME);
};

const redirectToSwapForCredit = ({ navigate }: { navigate: NavigateFunction }): void => {
  navigate(pages.SWAP_FOR_CREDIT.path);
};

export {
  redirectToLogin,
  redirectToDashboard,
  redirectToTrialCancel,
  redirectToFAQ,
  redirectToContactUsSwap,
  redirectToContactUsWelcome,
  redirectToSwapForCredit,
};
